// src/pages/pricingUnits/EditPricingUnit.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditPricingUnits from "../../components/pricingUnits/FormAddEditPricingUnits";
import useGetPricingUnit from "../../hooks/pricingUnits/useGetPricingUnit";
import LoadingPage from "../../components/global/LoadingPage";

const EditPricingUnit = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, pricingUnit } = useGetPricingUnit(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/pricing-units");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPricingUnits
                isEdit={true}
                currentData={pricingUnit}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditPricingUnit;
